
import MegaMenuAutomotiveDepartment from './MegaMenuAutomotiveDepartment.vue';
import MegaMenuDepartment from './MegaMenuDepartment.vue';
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { IWebSiteMenu } from 'Src/js/types/Header';

@Component({
	name: 'MegaMenu',
	components: {
		MegaMenuAutomotiveDepartment,
		MegaMenuDepartment
	}
})
export default class MegaMenu extends Vue {

	/* Props
	============================================*/

	@Prop({ type: Array, required: true })
	readonly departments: IWebSiteMenu[];

	/* Computed
	============================================*/

	get automotiveMenuItem(): IWebSiteMenu {
		return this.departments?.find(x => x.id === '12');
	}
	get animalRxMenuItem(): IWebSiteMenu {
		return this.departments?.find(x => x.id === '13');
	}

	/* Data
	============================================*/

	activeMenuId: string = "";
	automotiveMenuId: string = "12";
	animalRxMenuId: string = "13";

	/* Lifecycle Hooks
	============================================*/

	mounted() {
		const content = document.getElementById('contentWrapper');
		if (!content) return;
		content.classList.add('shadowed');
	}

	destroyed() {
		const content = document.getElementById('contentWrapper');
		if (!content) return;
		content.classList.remove('shadowed');
	}

	/* Methods
	============================================*/

	toggleDepartment(departmentId: string) {
		this.activeMenuId = this.activeMenuId !== departmentId
			? departmentId
			: "";
	}

	/* Watchers
	============================================*/

	@Watch('departments')
	ondepartmentsChanged(departmentsNew: IWebSiteMenu[]) {
		if (!departmentsNew?.length) return;
		this.activeMenuId = departmentsNew[0].id;
	}

}
